import { useEffect, useState } from 'react';

const links = [
  { label: 'Home', href: '#home' },
  { label: 'About', href: '#about' },
  { label: 'Craft', href: '#craft' },
  { label: 'Contact', href: '#contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 ${
        scrolled ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70' : 'bg-transparent'
      }`}
    >
      <nav className="flex items-center justify-between h-20 px-4 md:px-8">
        <a
          href="#home"
          className="flex items-center gap-3 whitespace-nowrap"
          onClick={() => setOpen(false)}
        >
          <span className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-goblet-line text-lg"></i>
          </span>
          <span className="font-heading font-semibold tracking-[0.18em] text-sm md:text-base text-foreground-950">
            23 BOTTLES <span className="text-primary-600">OF BEER</span>
          </span>
        </a>

        <div className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-sm font-medium tracking-wide text-foreground-700 hover:text-primary-600 transition-colors whitespace-nowrap"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#contact"
            className="whitespace-nowrap inline-flex items-center gap-2 rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 hover:bg-primary-600 active:bg-primary-700 transition-colors"
          >
            Contact Us
          </a>
        </div>

        <button
          type="button"
          aria-label="Toggle menu"
          className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-900"
          onClick={() => setOpen((v) => !v)}
        >
          <i className={`text-2xl ${open ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </nav>

      {open && (
        <div className="md:hidden bg-background-50/98 backdrop-blur-md border-t border-background-200/70 px-6 py-6 flex flex-col gap-1">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="py-3 text-base font-medium text-foreground-800 hover:text-primary-600 transition-colors"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#contact"
            onClick={() => setOpen(false)}
            className="mt-3 inline-flex items-center justify-center rounded-md bg-primary-500 px-5 py-3 text-sm font-semibold text-background-50 hover:bg-primary-600 transition-colors"
          >
            Contact Us
          </a>
        </div>
      )}
    </header>
  );
}